<template>
  <div v-show="showSuccess">
    <div role="alert" class="tw-border tw-border-green-600 tw-text-green-600 tw-px-4 tw-py-3 tw-rounded-lg tw-mb-8">
        <span class="block sm:inline">Ihre Daten wurden aufgenommen!</span>
    </div>
  </div>
  <div v-show="alreadyExists">
    <div role="alert" class="border border-red-600 text-red-600 px-4 py-3 rounded-lg mb-8">
        <span class="block sm:inline">Ihre Daten wurden bereits aufgenommen! Potenzielle Änderungen wurden nicht übernommen.</span>
    </div>
  </div>

  <div v-if="!showSuccess && !alreadyExists" :view="view" class="AAAAAAA">
    <Vueform
      ref="form$"
      :views="views"
      :schema="schema"
      :steps="steps"
      :endpoint="false"
      @submit="async function() { submitForm(true) }"
      @focusout="async function() { submitForm(false) }"
      @enterlast="async function() {
        submitForm(false)
        generatePdf()
      }"
      ></Vueform>
  </div>
</template>

<script>
import axios from 'axios'
import { buildSummary } from '../vueform/Summary'

export default {
  data: () => ({
    views: {},
    schema: {},
    steps: {},
    formInfo: {},
    inputUuid: null,
    session: '',
    user_reference: '',
    showSuccess: false,
    alreadyExists: false, // disable requests/form after already submitted
    submitting: false, // disable requests during submission
    wasSubmitted: false, // disable non submit requests after failed submission
    saveProgress: false,
    basehost: '',
    generatesPdf: false,
  }),
  methods: {
    async submitForm(completed) {
      if (this.submitting
        || ((this.wasSubmitted || !this.saveProgress) && !completed)) {
        return
      }
      else if (completed) {
        this.submitting = true
        this.wasSubmitted = true
      }

      try {
        let payload = this.$refs.form$.requestData

        for(let element in payload) {
          if (payload[element] instanceof Blob
              && payload[element].type == 'image/png'
          ) {
            let blobFile = new File([payload[element]], element + '.png');
            
            payload[element] = await uploadBlob(blobFile, element, this.inputUuid, this.savefile)
          }
        }

        let response = await axios.post(this.$attrs['saveform'], {
          input:          payload,
          formId:         this.formInfo.id,
          session:        this.session,
          user_reference: this.user_reference,
          inputUuid:      this.inputUuid,
          module:         this.module,
          completed:      completed
        }).catch(function (error) {
          return error.response
        })

        if (response.status == 403) {
          this.alreadyExists = true
        }

        if (completed && response.status == 200) {
          this.showSuccess = response.status
          window.scrollTo(0,0);
        }

        if (completed) {
          this.submitting = false
        }
      }
      catch (error) {
        if (completed) {
          this.submitting = false
        }
      }
    },
    async generatePdf() {
      if (!this.generatesPdf) {
        return
      }
      this.schema['pdf-download']['disabled'] = true

      try {
        let response = await axios.post(
          this.basehost + '/api/form/pdf/' + this.inputUuid
        ).catch(function (error) {
          this.schema['pdf-download']['disabled'] = true
          return
        })

        if (response.status == 200) {
          this.schema['pdf-download']['href'] = this.basehost + '/api/form/pdf/' + this.inputUuid
          this.schema['pdf-download']['disabled'] = false
        }
      }
      catch (error) {
          this.schema['pdf-download']['disabled'] = true
      }
    },
    setUrl(el$, url) {
      el$.url = url
    }
  },
  async mounted() {
    this.user_reference = this.$attrs['user_reference'] ?? ''
    this.session = this.$cookies.get('vf_session') ?? ''
    this.basehost = this.$attrs['basehost'] ?? ''
    this.saveProgress = parseInt(this.$attrs['save_progress'] ?? false)
    this.module = this.$attrs['module']
    this.generatesPdf = this.$attrs['generates_pdf']
    
    window.module = this.$attrs['module'] // used in validation

    const params = new URLSearchParams({
      module: this.$attrs['module'],
      session: this.session,
      user_reference: this.user_reference,
      fill_data: this.$attrs['fill_data'],
    })

    this.formInfo = (await axios.get(this.$attrs['fetchform'] + '?' + params.toString())).data

    if (this.saveProgress && !this.session && !this.user_reference && this.formInfo.session) {
      this.$cookies.set('vf_session', this.formInfo.session, '7d');
      this.session = this.formInfo.session
    }

    this.schema = this.formInfo.definition.schema
    this.steps = this.formInfo.definition.steps
    this.inputUuid = this.formInfo.inputUuid

    let view = this.$attrs['view'] ?? null
    this.views = {
      "FormSteps": view,
      "FormStep": view,
      "FormStepsControl": view,
    }

    let inputUuid = this.formInfo.inputUuid
    let refs = this.$refs

    if (this.steps && Object.keys(this.steps).length) {
      this.steps['end_step'] = {
        "label": "Abschluss",
        "elements": [],
        "labels": {
              "previous": "Zurück",
            "finish": this.formInfo.submit_text ?? "Zahlungspflichtig bestellen"
        },
        onActivate() {
          refs.form$.$emit('enterlast')
        }
      }

      this.steps['end_step']['elements'] = []
      if (parseInt(this.$attrs['show_summary'] ?? false)) {
        const schema = this.schema
        const summaryTemplate = this.$attrs['summary_template']
        this.steps['end_step']['elements'].push('form_summary')
        this.schema['form_summary'] = {
          type: 'static',
          content: function ($el) {
            return buildSummary(summaryTemplate, $el.form$.requestData, schema, $el.form$.steps)
          },
          tag: 'p',
        }
      }

      if (this.formInfo.completion_text) {
        this.steps['end_step']['elements'].push('completion_text')
        this.schema['completion_text'] = {
          type: 'static',
          content: this.formInfo.completion_text,
          tag: 'p',
        }
      }
    }
    else {
      let hasSubmit = false
      for (const [key, value] of Object.entries(this.schema)) {
        if ((value.submits ?? false) === true) {
          hasSubmit = true
        }
      }

      if (!hasSubmit) {
        this.schema['submit'] = {
            type: 'button',
            buttonLabel: this.formInfo.submit_text ?? "Zahlungspflichtig bestellen",
            submits: true,
            align: 'right',
          }
      }

      this.steps = null
    }

    let savefile = this.$attrs['savefile']
    this.savefile = this.$attrs['savefile'] // TODO clean this up and test regular upload
    let deletefile = this.$attrs['deletefile']

    if (this.generatesPdf) {
      this.schema['pdf-download'] = {
        "disabled": true,
        "ref": "downloadButton",
        "name": "pdf-download",
        "description": "",
        "type": "button",
        "rules": [],
        "href": '',
        "buttonType": "anchor",
        "buttonLabel": "Zusammenfassung herunterladen",
        "conditions": []
      }

      this.steps['end_step']['elements'].push("pdf-download")
    }

    function attachEndpoints(schema, basehost, inputUuid, savefile, deletefile) {
      for (const [key, value] of Object.entries(schema)) {
        if (value.type == 'list') {
          if (schema[key]['element']['schema'] ?? false) {
            attachEndpoints(schema[key]['element']['schema'], basehost, inputUuid, savefile, deletefile)
          }
          else {
            attachEndpoints(schema[key]['element'], basehost, inputUuid, savefile, deletefile)
          }
        }
        if (value.type == 'group') {
          attachEndpoints(schema[key]['schema'], basehost, inputUuid, savefile, deletefile)
        }
        if (value.type == 'file' || value.type == 'multifile') {
          schema[key]['upload-temp-endpoint']
            = async function(file, el$) {
            if (value.type == 'multifile') {
              return await uploadMultiFile(file, el$, inputUuid, key, savefile)
            }
            else {
              return await uploadFile(file, el$, inputUuid, savefile)
            }
          }
          schema[key]['remove-temp-endpoint'] = schema[key]['remove-endpoint']
            = async function(fileName, el$) {
            return removeFile(fileName, el$, inputUuid, deletefile)
          }
          schema[key]['onChange'] = async function() {
            refs.form$.$emit('focusout')
          }

          schema[key]['url'] = basehost + '/form/asset/' + inputUuid + '/' + key
        }
        if (value.type == 'signature') {
          if ((schema[key]['default'] ?? '').includes('.png')) {
            schema[key]['default'] = basehost + '/form/asset/' + inputUuid + '/' + key + '/' + key + '.png'
          }
        }
      }
    }

    attachEndpoints(this.schema, this.basehost, this.inputUuid, savefile, deletefile)
  },
}
async function uploadFile(file, el$, inputUuid, endpoint) {
  const uploadData = new FormData();
  uploadData.append('file', file);
  uploadData.append('fieldName', el$.name);
  uploadData.append('inputUuid', inputUuid);
  const res = await axios.post(endpoint, uploadData)

  return res.data['files'][0]['name'] ?? null
}
async function uploadMultiFile(file, el$, inputUuid, fieldName, endpoint) {
  const uploadData = new FormData();
  uploadData.append('file', file);
  uploadData.append('fieldName', fieldName);
  uploadData.append('index', el$.name);
  uploadData.append('inputUuid', inputUuid);
  uploadData.append('multifile', 1);
  const res = await axios.post(endpoint, uploadData)

  return res.data['files'][0]['name'] ?? null
}
async function uploadBlob(file, name, inputUuid, endpoint) {
  const uploadData = new FormData();
  uploadData.append('file', file);
  uploadData.append('fieldName', name);
  uploadData.append('inputUuid', inputUuid);
  uploadData.append('overwrite', true);
  const res = await axios.post(endpoint, uploadData)

  return res.data['files'][0]['name'] ?? null
}
async function removeFile(fileName, el$, inputUuid, endpoint) {
  const deleteData = new FormData();
  deleteData.append('fileName', fileName);
  deleteData.append('fieldName', el$.name);
  deleteData.append('inputUuid', inputUuid);
  const res = await axios.post(endpoint, deleteData)

  return res
}
</script>
